import { render } from "./ExibAtu.vue?vue&type=template&id=a68583a6&scoped=true"
import script from "./ExibAtu.vue?vue&type=script&lang=js"
export * from "./ExibAtu.vue?vue&type=script&lang=js"

import "./ExibAtu.vue?vue&type=style&index=0&id=a68583a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a68583a6"]])

export default __exports__